import api from "../../../api/axios";

// Feature-local wrappers for ClientPropertyMatch endpoints used by the
// /clients/:clientId matches section (CRM-WORKFLOW-D1 +
// CRM-CLIENT-CONTACTS-MATCHING-A1).
//
// Endpoints:
//   GET  /api/crm/clients/{clientId}/matches/?page=&page_size=&status=&ordering=
//   PATCH /api/crm/clients/{clientId}/matches/{matchId}/
//   POST /api/crm/clients/{clientId}/matches/recompute/ → 202
//
// Stateless request wrappers — no cache, no retry, no invalidation.

export const fetchClientMatches = (clientId, params = {}, { signal } = {}) =>
  api
    .get(`/crm/clients/${clientId}/matches/`, { params, signal })
    .then((res) => res.data);

export const updateClientMatchStatus = (clientId, matchId, status) =>
  api
    .patch(`/crm/clients/${clientId}/matches/${matchId}/`, { status })
    .then((res) => res.data);

export const requestClientMatchesRecompute = (clientId) =>
  api
    .post(`/crm/clients/${clientId}/matches/recompute/`)
    .then((res) => res.data);
